import { useEffect, useState } from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import useCalculatePreBasketQnt from "../../Universal/hooks/useCalculatePreBasketQnt";
import { Assort } from "../../../models/Assort";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import {
  GDANSK_KIND_BEARER_PASS,
  GDANSK_KIND_PASS_OPEN,
  GDANSK_KIND_SWIMMING_TRACK,
  GDANSK_PASS,
  GDANSK_TICKET,
  getTitleByProductKind,
} from "../Steps/gdanskSaleStepsConsts";
import { ADD_TO_BASKET_URL, GET_LEGACY_ASSORTS } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";
import { get, post } from "../../../api";
import { UNKNOWN_ERROR } from "../../../api/tryCatchRequest";
import getId from "../../../../utils/getId";
import { setTicketAccessFromExercise } from "../../../models/TicketAccess";
import { BasketItem } from "../../../models/BasketItem";
import { QntStateItem } from "../../../models/QntStateItem";
import { setErrors } from "../../../store/alerts/alertsActions";
import { useDispatch } from "react-redux";
import { FINALIZE_PAGE } from "../../../routes";
import { useNavigate } from "react-router";
import { format } from "date-fns";

/* eslint-disable import/no-anonymous-default-export */
export default (form: GdanskSaleForm, setForm: (form: GdanskSaleForm) => void, onGoBack: () => void) => {
  const facilityIds = useFacility();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [assorts, setAssorts] = useState<Assort[]>([]);
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket } = usePreBasket();
  const { qntState } = useCalculatePreBasketQnt(preBasket);

  const getTitleByProductType = () => {
    if (form.productMainType === GDANSK_TICKET) {
      if (form.kind === GDANSK_KIND_SWIMMING_TRACK) {
        return "Potwierdź dodanie biletu dla instruktora";
      } else {
        return "Wybierz rodzaj biletu";
      }
    } else if (form.productMainType === GDANSK_PASS) {
      return "Wybierz rodzaj karnetu";
    } else {
      return "Wybierz";
    }
  };

  const getAssorts = async () => {
    setLoading(true);
    const { result, isError } = await get(
      GET_LEGACY_ASSORTS(
        facilityIds,
        form.kind,
        form.exercise ? getId(form.exercise.exerciseGroup) : "",
        form.bookingGroupIds,
        form.materialGroupIds,
        form.colorIds
      )
    );
    if (!isError) {
      setAssorts(result);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAssorts();
    //eslint-disable-next-line
  }, []);

  const getQnt = (value: Assort): number => {
    if (qntState && qntState.length > 0 && getId(form.exercise)) {
      const foundQnt = qntState.find(
        (item) => item.assortIds === getId(value) && String(form.exercise.objectId) === item.exerciseIds
      );
      return foundQnt ? foundQnt.count : 0;
    } else {
      const itemBasket = preBasket.find((item) => item.assortIds === getId(value));
      return itemBasket ? itemBasket.qnt : 0;
    }
  };

  const onAssortAdd = (assort: Assort) => {
    if (getId(form.exercise)) {
      const ticketAccess = setTicketAccessFromExercise(
        form.exercise.objectId,
        form.exercise.name,
        form.exercise.startTime
      );
      addItemToBasket(assort, ticketAccess);
    } else if (form.kind === GDANSK_KIND_PASS_OPEN || form.kind === GDANSK_KIND_BEARER_PASS) {
      addItemToBasket({ ...assort, validFromDate: form.date.getTime() });
    } else {
      addItemToBasket(assort);
    }
  };

  const onAssortDelete = (assort: Assort) => {
    if (getId(form.exercise)) {
      const ticketAccess = setTicketAccessFromExercise(
        form.exercise.objectId,
        form.exercise.name,
        form.exercise.startTime
      );
      removeItemFromBasket(assort, ticketAccess);
    } else {
      removeItemFromBasket(assort);
    }
  };

  const ticketsInCurrentBasket = () => {
    if (qntState && qntState.length > 0 && getId(form.exercise)) {
      return qntState
        .filter((item) => item.exerciseIds === String(form.exercise.objectId))
        .reduce((acc: number, item: QntStateItem) => acc + item.count, 0);
    } else {
      return preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);
    }
  };

  const getTicketLimit = () => {
    if (getId(form.exercise)) {
      return form.exercise.capacity - (form.exercise.reserved + form.exercise.prereservation);
    } else {
      return 99; // TO PRZY np. KARNET OPEN GDZIE NIE MAMY WYBORU DATY
    }
  };

  const handleGoBack = () => {
    clearBasket();
    onGoBack();
  };

  const addToBasket = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(preBasket.map((item) => post(ADD_TO_BASKET_URL, item)));
      const failed = results.filter((r) => r.isError);
      if (failed.length > 0) {
        const errorMessages = failed.flatMap((r) => r.errorTable ?? []);
        dispatch(setErrors(errorMessages.length > 0 ? errorMessages : [UNKNOWN_ERROR]));
        return;
      }
      clearBasket();
      navigate(FINALIZE_PAGE);
    } finally {
      setLoading(false);
    }
  };

  const findInstructorAssort = () => {
    const ids = "0,1341"; // TUTAJ ID ASORTYMENTU JAKI DODAJEMY AUTOMATYCZNIE DLA INSTRUKTORA, MUSI ON BYĆ POBRANY Z FUNKCJI getAssorts(), INACZEJ NIE ZADZIAŁA
    return assorts.find((item) => getId(item) === ids);
  };

  const addInstructorAssort = async () => {
    const filteredAssort = findInstructorAssort();
    if (filteredAssort !== undefined && getId(filteredAssort)) {
      onAssortAdd(filteredAssort);
    } else {
      console.error("Nie znaleziono asortymentu specficznego dla instruktora.");
      dispatch(setErrors(["Nie znaleziono asortymentu specficznego dla instruktora."]));
    }
  };

  useEffect(() => {
    if (form.kind === GDANSK_KIND_SWIMMING_TRACK && assorts.length > 0) {
      addInstructorAssort();
    }
    //eslint-disable-next-line
  }, [form.kind, assorts]);

  const onSubmit = () => {
    addToBasket();
  };

  const getPreviousStepInfo = () => {
    const productTitle = getTitleByProductKind(form.kind);
    const exerciseStartTimeInfo =
      getId(form.exercise) && form.exercise.startTime
        ? format(new Date(form.exercise.startTime), "| dd.MM.yyyy HH:mm")
        : "";
    const exerciseGroupInfo =
      getId(form.exercise) && form.exercise.zone.displayName ? `| ${form.exercise.zone.displayName}` : "";
    const materialGroupName = form.materialGroupName ? `| ${form.materialGroupName}` : "";
    const bookingGroupName = form.bookingGroupName ? `| ${form.bookingGroupName}` : "";
    const colorName = form.colorName ? `| ${form.colorName}` : "";

    return `${productTitle} ${exerciseStartTimeInfo} ${exerciseGroupInfo} ${materialGroupName} ${bookingGroupName} ${colorName}`;
  };

  return {
    getTitleByProductType,
    ticketsInCurrentBasket,
    handleGoBack,
    loading,
    assorts,
    onAssortAdd,
    onAssortDelete,
    getQnt,
    getTicketLimit,
    onSubmit,
    getPreviousStepInfo,
    instructorAssort: findInstructorAssort(),
  };
};
